import CustomersList from "./customers/list";
import CustomersCreate from "./customers/create";
import ThemesList from "./themes/list";
import ThemesCreate from "./themes/create";
import ThemesDetails from "./themes/details";
import ProcessesList from "./processes/list";
import ProcessesCreate from "./processes/create";
import ProcessesDetails from "./processes/details";
import StepsCreate from "./steps/create";
import UsersList from "./users/list";
import FilesList from "./files/list";
import EntitiesList from "./entities/list";
import EntitiesDetails from "./entities/details";
import EventsList from "./events/list";
import UsersCreate from "./users/create";
import CompaniesList from "./companies/list";
import ThemeInsights from "./themes/insights";
import NotificationsList from "./notifications/list";

const Users = {
    List: UsersList,
    Create: UsersCreate
}

const Files = {
    List: FilesList,
}

const Events = {
    List: EventsList,
}

const Entities = {
    List: EntitiesList,
    Details: EntitiesDetails,
}

const Customers = {
    List: CustomersList,
    Create: CustomersCreate
}

const Themes = {
    List: ThemesList,
    Create: ThemesCreate,
    Details: ThemesDetails,
    Insights: ThemeInsights
}

const Processes = {
    List: ProcessesList,
    Create: ProcessesCreate,
    Details: ProcessesDetails,
}

const Notifications = {
    List: NotificationsList,
}

const Companies = {
    List: CompaniesList,
}

const Steps = {
    Create: StepsCreate,
}

export {Customers, Themes, Processes, Steps, Users, Entities, Files, Events, Notifications, Companies};